import { REPLICATION_SIZE } from '../../../utils/constants';
import {
  auditFields,
  buildReplication,
  getMutationArrayNestedValue,
  getMutationIsActive,
  getMutationNestedValue,
  getMutationNumberValue,
  getMutationStringValue
} from '../utils';

/**
 * Pull builder for processing data
 *
 * @param {*} db RxDB database
 */
const pullBuilder = (doc) => {
  const where = doc ? `lastmodifiedAt_Gt: "${doc.lastmodifiedAt}"` : '';

  const query = `{
    listProcessings(
      limit: ${REPLICATION_SIZE}
      offset: 0
      ordering: "lastmodifiedAt,ASC"
      ${where}
    ) {
      results {
        id
        icode

        dueTime
        status
        volume
        details

        bloodProductType { id name shelfLife shelfLifeUnit }
        bloodProcessingCenter { id name address }
        donation {
          id
          icode
          date
          length width volume
          bloodDonationCenter { id name address stockUnit { id name address } }
          donor { id donorCode fullName personName gender bloodType }
        }

        consumables { id name }
        equipments { id name }
        healthCareWorkers { username name }

        ${auditFields}
      }
    }
  }`;

  return { query, variables: {} };
};

/**
 * Push builder for processing data
 *
 * @param {*} db RxDB database
 */
const pushBuilder = (doc) => {
  const query = `
    mutation {
      upsertProcessing(
        input: {
          ${getMutationStringValue(doc, 'id')}
          ${getMutationStringValue(doc, 'dueTime')}
          ${getMutationStringValue(doc, 'status')}
          ${getMutationNumberValue(doc, 'volume')}
          ${getMutationStringValue(doc, 'details')}

          ${getMutationNestedValue(doc, 'bloodProductType')}
          ${getMutationNestedValue(doc, 'bloodProcessingCenter')}
          ${getMutationNestedValue(doc, 'donation')}

          ${getMutationArrayNestedValue(doc, 'consumableIds', 'consumables')}
          ${getMutationArrayNestedValue(doc, 'equipmentIds', 'equipments')}
          ${getMutationArrayNestedValue(doc, 'healthCareWorkerNames', 'healthCareWorkers', 'username')}

          ${getMutationIsActive(doc)}
        }
      ) {
        id
      }
    }
  `;

  return { query, variables: {} };
};

/**
 * Synchronize blood product data with GraphQL endpoint
 */
export const syncProcessing = (...args) => {
  return buildReplication(
    ...args,
    'processing',
    { pullBuilder, pullQuery: 'listProcessings' },
    { pushBuilder }
  );
};
